import React from 'react'
import styles from './FormCheckbox.module.scss'
import { FieldInputProps, FormikProps } from 'formik'
import classNames from 'classnames'

interface Props {
  field: FieldInputProps<boolean>
  form: FormikProps<any>
  id: string
  label: React.ReactNode
  name: string
  isRequired?: boolean
}

export const FormCheckbox: React.FC<Props> = ({
  field,
  form,
  id,
  label,
  name
}) => {
  const error = form.touched[name] && form.errors[name]

  const handleChange = (e: { target: { checked: any } }) => {
    form.setFieldValue(name, e.target.checked)
    form.setFieldTouched(name, true, false)
  }

  return (
    <div className={styles.CheckboxWrapper}>
      <label htmlFor={id} className={styles.CheckboxLabel}>
        <input
          id={id}
          name={name}
          type="checkbox"
          checked={!!field?.value}
          onChange={handleChange}
          className={classNames(styles.Checkbox, {
            [styles.Error]: !!error
          })}
        />
        <span>{label}</span>
      </label>
      {error && typeof error === 'string' && (
        <div className={styles.ErrorMessage}>{error}</div>
      )}
    </div>
  )
}
